






































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import DateMethods from '@/mixins/DateMethods.vue';
import Transaction from '@/ts/Transaction';


@Component({})
export default class OrderInformation extends Mixins(DateMethods) {

    constructor() {
        super();
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
    }

    get transaction(): Transaction {
        return this.$store.getters['UserWallet/getActiveTransaction'];
    }



    public created() {
        if (typeof this.$route.params.transactionId !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_TRANSACTION, this.$route.params.transactionId);
        }
    }

    public goBack() {
        this.$router.back();
    }

    get dataLoaded(): boolean {
        return (typeof this.transaction !== 'undefined' && this.transaction !== null);
    }
}
